<template>
    <span class="pl-2 pb-1 simple-pill d-inline-block"
          v-bind:class="{
            'pr-5': needsPadding(),
            'pr-2': !needsPadding(),
            'available': available && active,
            'disabled': !active,
            'outlined': outlined,
            'fixed-width': availableText || unavailableText
          }">
        <span v-if="text">{{getText()}}</span>
        <SvgIcon v-if="active && available && availableIcon" :icon="availableIcon" class="icon" :class="availableIcon"/>
        <SvgIcon v-if="active && !available && unavailableIcon" :icon="unavailableIcon" :class="unavailableIcon" class="icon"/>
        <SvgIcon v-if="!active && disabledIcon" :icon="disabledIcon" class="icon" :class="disabledIcon"/>
    </span>
</template>

<script>
    import SvgIcon from './SvgIcon';

    export default {
        name: "SimplePill",
        components: {
            SvgIcon
        },
        props: {
            text: {
                type: String,
                default: ''
            },
            active: {
                type: Boolean,
                default: true
            },
            available: {
                type: Boolean,
                default: false
            },
            availableIcon: {
                type: String,
                default: null
            },
            unavailableIcon: {
                type: String,
                default: null
            },
            disabledIcon: {
                type: String,
                default: null
            },
            outlined: {
              type: Boolean,
              default: false
            },
            availableText: {
              type: String,
              default: null
            },
            unavailableText: {
              type: String,
              default: null
            },
        },
        methods: {
          needsPadding() {
              return (this.active && this.available && this.availableIcon) ||
                (this.active && !this.available && this.unavailableIcon) ||
                (!this.active && this.disabledIcon)
          },
          getText() {
              if (this.active && this.available && this.availableText) {
                return this.availableText;
              }

              if (this.active && !this.available && this.unavailableText) {
                return this.unavailableText;
              }

              return this.text;
          }
        }
    }
</script>

<style scoped lang="scss">
    .icon {
        stroke: white;
        position: absolute;
        right: .5rem;
        top: .3rem;
    }

    .simple-pill {
        border-radius: 4px;
        background-color: $red;
        color: white;
        font-family: $primary-font;
        position: relative;
        text-decoration: none;

        &.fixed-width {
          min-width: 9rem;
          text-align: center;
        }

        &.outlined {
          background-color: transparent;
          border: 1px solid $red;
          color: $red;

          .icon {
            stroke: $red;
          }

          &:hover {
            color: $red;
          }
        }

        &.available {
            cursor: pointer;
            background-color: $green;

            &.outlined {
              background-color: transparent;
              border: 1px solid $green;
              color: $green;

              .icon {
                stroke: $green;
              }

              &:hover {
                color: $green;
              }
            }
        }

        &.disabled {
            cursor: pointer;
            background-color: $gray;

            &.outlined {
              background-color: transparent;
              border: 1px solid $gray;
              color: $gray;
              .icon {
                stroke: $gray;
              }

              &:hover {
                color: $gray;
              }
            }
        }

        &:hover {
            color: white;
        }
    }
</style>
